import { useCallback } from "react";
import { useAtom } from "jotai";

import { onboardingStepAtom } from "../jotai/atoms/onboarding";
import { OnboardingSteps } from "../utils/constants";

function useOnboardingSteps() {
  const [onboardingStep, setOnboardingStep] = useAtom(onboardingStepAtom);

  const goToStep = useCallback(
    (step: OnboardingSteps) => {
      setOnboardingStep(step);
    },
    [setOnboardingStep]
  );

  return { goToStep, currentStep: onboardingStep };
}

export default useOnboardingSteps;
